const index = require('./lib');

module.exports = index;
